import { useState } from "react";
import { useEffect } from "react";
import { getCurrentUser } from "../../utils/auth";

function SignIn() {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [selectedPlan, setSelectedPlan] = useState(null);
const [showInput, setShowInput] = useState(false);
const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
const heRedirectUrl = "https://ghanagameium.com/api/cgw/callback";
const heMobileNumber = "99999999999";

useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const connection =
    navigator.connection ||
    navigator.mozConnection ||
    navigator.webkitConnection;
  const connectionType = connection?.type?.toLowerCase();
  const isMobileView = window.matchMedia("(max-width: 767px)").matches;
  const isMobileDevice = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  const shouldUseNheOnMobile =
    isMobileDevice && isMobileView && connectionType === "wifi";

  if (params.get("fallback") === "true" || shouldUseNheOnMobile) {
    setShowInput(true);
  } else {
    setShowInput(false); // ✅ IMPORTANT FIX
  }
}, []);

useEffect(() => {
  const verifyExistingSession = async () => {
    if (!localStorage.getItem("accessToken")) return;

    const currentUser = await getCurrentUser();

    if (currentUser.success && currentUser.isSubscribed) {
      window.location.href = "/play";
    }
  };

  verifyExistingSession();
}, []);

  const plans = [
    {
      code: "9919910026",
      name: "Daily Pack",
      duration: "1 Day",
      price: "GHS 1",
      popular: true,
      features: ["Unlimited Access", "Mobile Access", "Basic Support"],
    },
    {
      code: "9919910027",
      name: "Weekly Pack",
      duration: "7 Days",
      price: "GHS 6",
      features: ["Unlimited Access", "HD Quality", "Early Access"],
    },
    {
      code: "9919910028",
      name: "Monthly Pass",
      duration: "30 Days",
      price: "GHS 18",
      features: [
        "Unlimited Access",
        "HD Quality",
        "All Devices",
        "Priority Support",
      ],
    },
  ];


const handleSubscribe = (planCode) => {
  const selected = planCode || selectedPlan;

  if (!selected) {
  alert("Please select a plan");
  return;
}

  // 🔥 अगर input दिख रहा है → number जरूरी
  if ((!isMobile || showInput) && !phoneNumber) {
    alert("Please enter phone number");
    return;
  }

  // simple validation
  if (phoneNumber && phoneNumber.length < 9) {
    alert("Enter valid phone number");
    return;
  }

  // plan save
  localStorage.setItem("offerCode", selected);

  if (isMobile && !showInput) {
    const params = new URLSearchParams({
      offerCode: selected,
      redirectUrl: heRedirectUrl,
      mobileNumber: heMobileNumber
    });

    const finalUrl = `/api/cgw/he-redirect?${params.toString()}`;

    console.log("SIGNIN HE FLOW START");
    console.log("SIGNIN HE OFFER:", selected);
    console.log("SIGNIN HE CALLBACK:", heRedirectUrl);
    console.log("SIGNIN HE MOBILE:", heMobileNumber);
    console.log("SIGNIN HE FINAL URL:", finalUrl);

    window.location.href = finalUrl;
    return;
  }

  // 🔥 NUMBER SAVE (IMPORTANT)
  if (phoneNumber) {
    const msisdn = "233" + phoneNumber;
    localStorage.setItem("msisdn", msisdn);

    const params = new URLSearchParams({
      offerCode: selected,
      msisdn
    });

    const finalUrl = `/api/cgw/generate-url?${params.toString()}`;

    console.log("SIGNIN NHE FLOW START");
    console.log("SIGNIN NHE OFFER:", selected);
    console.log("SIGNIN NHE MSISDN:", msisdn);
    console.log("SIGNIN NHE FINAL URL:", finalUrl);

    window.location.href = finalUrl;
    return;
  }

  // redirect
  window.location.href = "/signin?fallback=true";
};
  return (
    <div
      className="min-h-screen bg-cover bg-center relative"
      style={{
        backgroundImage: "url('/assets/images/post-img-6.png')",
      }}
    >
      <div className="absolute inset-0 bg-[#0b0b15]/90" />

      <div className="relative z-10 pt-24 pb-10 px-4">

        <h2 className="text-4xl font-bold text-center mb-8 text-white">
          Choose Your Plan
        </h2>

        {/* PHONE INPUT */}
       {(!isMobile || showInput) && (
  <div className="max-w-md mx-auto mb-8">
    <div className="flex items-center bg-[#1f1f35] rounded-xl px-4 py-3">
      <img
        src="https://flagcdn.com/w40/gh.png"
        alt="ghana"
        className="w-6 h-4 mr-3 rounded-sm"
      />

      <span className="text-gray-300 mr-2">+233</span>

      <input
        type="tel"
        placeholder="Enter phone number"
        value={phoneNumber}
        onChange={(e) => setPhoneNumber(e.target.value)}
        className="flex-1 bg-transparent text-white outline-none"
      />
    </div>
  </div>
)}

        {/* PLANS */}
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-5">

          {plans.map((plan) => (
            <div
              key={plan.code}
              onClick={() => {
  setSelectedPlan(plan.code);
  handleSubscribe(plan.code);
}}
              className={`relative p-5 rounded-2xl cursor-pointer transition-all
              ${
                selectedPlan === plan.code
                  ? "border-2 border-yellow-400 scale-105 bg-[#141422]"
                  : "border border-[#ffffff20] bg-[#141422]/90"
              }`}
            >

              {plan.popular && (
                <div className="absolute top-3 right-3 bg-yellow-400 text-black text-xs px-3 py-1 rounded-full">
                  Most Popular
                </div>
              )}

              <h3 className="text-lg font-bold text-white">{plan.name}</h3>
              <p className="text-gray-400 mb-3">{plan.duration}</p>

              <h2 className="text-2xl font-bold mb-4 text-yellow-400">
                {plan.price}
              </h2>

              <div className="space-y-2 mb-4">
                {plan.features.map((f, i) => (
                  <p key={i} className="text-gray-300 text-sm">
                    ✔ {f}
                  </p>
                ))}
              </div>

              <button
                className={`w-full py-2 rounded-lg font-semibold transition
                ${
                  selectedPlan === plan.code
                    ? "bg-green-500 text-white"
                    : "bg-yellow-400 text-black hover:bg-yellow-300"
                }`}
              >
                {selectedPlan === plan.code ? "Selected" : "Select"}
              </button>
            </div>
          ))}
        </div>

      

      </div>
    </div>
  );
}

export default SignIn;
